export default "__VITE_ASSET__CNARFn_r__"